import type { AdvancedPost } from '@/api';

export const useAdvancedPostPolicy = (app: Ref<AdvancedPost | undefined>) => {
    const { company, authorized_branches, permissions } = useCompany();
    const getPolicy = (post: AdvancedPost | undefined) => {
        const isMine =
            post != null &&
            ((post.postable_type === 'company' && post.postable_id === company.value?.id) ||
                (post.postable_type === 'company_branch' &&
                    authorized_branches.value?.some(a => post.postable_id === a.id)));

        const edit = isMine && permissions.value.updatePublicPage;
        const event = {
            register: post?.post_type === 'event' && post?.meta?.event_registration?.enabled && !isMine,
            viewRegistrants:
                post?.post_type === 'event' &&
                (post?.meta?.event_registration?.enabled || post?.event_registrants) &&
                edit,
        };

        return {
            event,
            edit,
            delete: edit,
        } as const;
    };

    const policy = computed(() => getPolicy(app.value));

    return { policy, getPolicy };
};
